var render = function render(){var _vm=this,_c=_vm._self._c;return _c('color-picker',{attrs:{"id":_vm.id,"name":_vm.name,"label":_vm.label,"value":_vm.colour,"color":_vm.colour,"color-default":_vm.colorDefault,"picker":"chrome"},model:{value:(_vm.colour),callback:function ($$v) {_vm.colour=$$v},expression:"colour"}})
}
var staticRenderFns = []

export { render, staticRenderFns }